// extracted by mini-css-extract-plugin
export default {"systemAdminAccess":"styles_systemAdminAccess__EC8DZ"};